import React, { useState } from 'react';
import { CalculatorState, defaultCalculatorState, formFields } from "./";
import { Input } from "components/form/input";
import { GET_QUOTE } from "app/queries/Quote";
import { useQuery, useMutation } from "@apollo/react-hooks";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Confirmation } from '../confirmation';
import { QuoteInterface } from "../confirmation/Confirmation.types";
import { ExecutionResult } from "graphql";

export function Calculator() {
  const [state, setState] = useState<CalculatorState>(defaultCalculatorState)
  const {groupSize, pickUpAddress, dropOffAddress} = state.form
  const { formSubmitted } = state
  const [ getQuote ] = useMutation(GET_QUOTE);

  async function submitForm() {
    let invalidData = false;
    let errors: string[] = []

    if(pickUpAddress.value === dropOffAddress.value) {
      toast.warn('Pick up address cannot be the same as drop off address.')
    } else if(!invalidData) {
      try{
        const response: ExecutionResult<QuoteInterface> = await getQuote({
          variables: {
            groupSize: Number(groupSize.value),
            pickUpAddress: pickUpAddress.value,
            dropOffAddress: dropOffAddress.value
          }
        })
        console.log(response.data);
        setState({...state, quote: response.data!, formSubmitted: true})
      } catch {
        toast.warn('Invalid Data')
      }
    } else toast.warn('Invalid Data: ' + errors)
  }

  if(formSubmitted && state.quote?.calculateQuote.success) {
    return <Confirmation
      quote={state.quote!}
      groupSize={groupSize.value}
      pickUpAddress={String(pickUpAddress.value)}
      dropOffAddress={String(dropOffAddress.value)}
      onReset={(clear) => clear ? setState(defaultCalculatorState) : setState({...state, formSubmitted: false})}
    />
  }
  return (
      <div className='row'>
        {
          formFields.map(field =>
              <Input label={field.label}
                     fieldName={field.fieldName}
                     col={field.col}
                     type={field.type}
                     validationRule={field.validationRule}
                     required={field.required}
                     tooltip={field.tooltip ?? undefined}
                     // @ts-ignore
                     value={state.form[field.fieldName].value}
                     updateFormData={(field, input, valid) => setState({...state, form: {...state.form, [field]: {value: input, valid}}})}
              />
          )
        }
          <div className='form-group col-12'>
              <button className="btn d-inline" disabled={Object.values(state.form).find(x => !x?.valid) && true} onClick={() => submitForm()}>Submit</button>
            {
              formSubmitted && !state.quote?.calculateQuote.success &&
              <h4 className='d-block d-md-inline ml-0 ml-md-3 mt-2 mt-md-0'>{state.quote?.calculateQuote.message}</h4>
            }
          </div>
      </div>
  )
}